<template>
  <v-container>
    <v-timeline clipped v-if="histories && histories.length">
      <v-timeline-item
        v-for="history in histories"
        :key="history._id"
        :class="`mb-3 text-xs-${!history.type ? 'left': 'right'}`"
        :color="!history.type ? history.status === 'current' ? 'green' : history.status === 'pending' ? 'orange' : 'grey' : 'blue lighten-4'"
        :small="!history.type"
        :large="!!history.type"
        :left="!!history.type"
        :right="!history.type"
      >
        <template v-slot:icon v-if="history.type">
          <v-icon small>calendar_today</v-icon>
        </template>
        <v-layout justify-space-between v-if="!history.type">
          <v-flex xs7>
            <div>Fichier déposé le {{history.createdAt | formatDateTime}}</div>
            <div>Utilisateur : {{history.username}}</div>
            <div>Nombre de lignes : {{history.count}}</div>
          </v-flex>
          <v-flex xs5 text-xs-right>
            <v-btn icon @click="downloadFile(history._id)">
              <v-icon color="grey">cloud_download</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <div v-else class="title">{{history.createdAt | formatDate}}</div>
      </v-timeline-item>
    </v-timeline>
    <div v-else>Pas d'historique pour le moment...</div>
  </v-container>
</template>

<script>
import axios from "axios";
import { format, parseISO } from "date-fns";
import frLocale from "date-fns/locale/fr";

export default {
  props: ["histories"],
  data: () => ({
    timeout: undefined
  }),
  methods: {
    downloadFile: async function(id) {
      const { data } = await axios({
        method: "GET",
        url: `${process.env.VUE_APP_API_URI}/files/${id}`
      });
      const decoded = Buffer.from(data.buffer);
      var newBlob = new Blob([decoded], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const pdfData = window.URL.createObjectURL(newBlob);
      var link = document.createElement("a");
      link.href = pdfData;
      link.download = `${data.originalname}`;
      link.click();
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        window.URL.revokeObjectURL(pdfData);
      }, 100);
    }
  },
  filters: {
    formatDateTime: function(date) {
      return format(parseISO(date), "d MMMM yyyy à HH:mm", {
        locale: frLocale
      });
    },
    formatDate: function(date) {
      return format(parseISO(date), "d MMMM yyyy", { locale: frLocale });
    }
  }
};
</script>